import { render, staticRenderFns } from "./CreatePurchaseOtherInvoice.vue?vue&type=template&id=5c924763"
import script from "./CreatePurchaseOtherInvoice.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseOtherInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports